export default __webpack_public_path__ + "690730211cb9507351452bc78f299c75.png";